import React, { useEffect, useState } from "react";
import { DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import { Space, Layout, Table, Card, Button, PageHeader, Popconfirm, message } from "antd";
import {saveAs} from 'file-saver'
import R2Footer from "../../../components/Footer";
import "./style.scss";
import QrServices from "../../../services/qrServices";

const { Content } = Layout;

export default function QrCode() {

  const [allQrCode, setAllQrCode] = useState({});
  const [deliveryQr, setDeliveryQr] = useState('');
  const [waitlistQr, setWaitlistQr] = useState('');

  const getAllQR = () => {
    QrServices.getAllMenuQr().then((res)=>{
      if(res){
        setAllQrCode(res);
      }
    });
  };
  const getGenerateCode = (id, stateFun) => {
    QrServices.getGeneratedQR(id).then((res)=>{
      if(res){
        stateFun(res);
      }
    })
  }
  useEffect(()=>{
    getAllQR();
    getGenerateCode('DELIVERY', setDeliveryQr);
    getGenerateCode('WAITLIST', setWaitlistQr);
  },[]);

  const onDeleteQr = (id) => {
    QrServices.deleteQr(id).then((res)=>{
      if(res){
        getAllQR();
        message.success('Deleted successfully');
      }
    })
  };
  const onDeleteQrType = (type) => {
    QrServices.deleteQrType(type).then((res)=>{
      if(res){
        if(type === "WAITLIST")
        setWaitlistQr("")
        else
        setDeliveryQr("")
        message.success('Deleted successfully');
      }
    })
  };
  const downloadImage = async (img, sec) => {
    const blob = img;
    saveAs(blob, `${sec}-qrimage.png`);
  };
  const reGenerateCode = (type) => {
    const urlVal = type=== 'WAITLIST' ?  `${process.env.REACT_APP_CUSTOM_APP_URL}/${localStorage.getItem('restaurantId')}/waitlist` : `${process.env.REACT_APP_MOBILE_APP_URL}`;
    QrServices.generateQRCode(type, {url: urlVal}).then((res)=>{
      if(res){
        if(type === 'DELIVERY') {
          getGenerateCode('DELIVERY', setDeliveryQr);
        } else {
          getGenerateCode('WAITLIST', setWaitlistQr);
        }
      }
    })
  };
  const generateCode = (type) => {
    const urlVal = type=== 'WAITLIST' ?  `${process.env.REACT_APP_CUSTOM_APP_URL}/${localStorage.getItem('restaurantId')}/waitlist` : `${process.env.REACT_APP_MOBILE_APP_URL}`;
    QrServices.newCodeGeneration({url: urlVal, qr_type: type}).then((res)=>{
      if(res){
        if(type === 'DELIVERY') {
          getGenerateCode('DELIVERY', setDeliveryQr);
        } else {
          getGenerateCode('WAITLIST', setWaitlistQr);
        }
      }
    })
  };
  return (
    <Layout className="u-page-layout">
      <Content className="page-padding">
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader title="QR Codes" style={{minHeight:80}} className="d-flex items-center page-header-business"/>
        </Space>
        <div className="content-container-business">
          <Card className="card-qr">
            <div className="qr-card-container">
              <div style={{ textAlign: "start" }}>
                <div style={{ color: "#C32340", fontWeight: "bold" }}>
                  Waitlist QR Code
                </div>
                <div style={{ marginTop: 12 }}>
                  {waitlistQr
                    ? "Here is the QR code for online waitlist management."
                    : "You don’t have a QR code setup for Waitlist. Would you like to generate one?"}
                </div>
                {waitlistQr && (
                  <div style={{ marginTop: 12 }}>
                    <Button
                      type="primary"
                      className="custom-btn"
                      style={{ marginRight: 16 }}
                      onClick={()=>reGenerateCode('WAITLIST')}
                    >
                      Regenerate QR
                    </Button>
                    {/* <Button type="primary" className="custom-btn" onClick={()=> downloadImage(waitlistQr.data_url, 'waitlist')}>
                      Download QR
                    </Button> */}
                    <Button type="secondary" className="custom-btn" onClick={()=> onDeleteQrType( 'WAITLIST')}
                      style={{borderColor:"#C32340",color:"#C32340",width:"150px"}}>
                      Delete
                    </Button>
                  </div>
                )}
              </div>
              {waitlistQr ? (
                <img src={waitlistQr?.data_url} width={100} /> 
              ) : (
                <Button type="primary" className="custom-btn" style={{ marginRight: 16 }} onClick={()=>generateCode('WAITLIST')}>
                  Generate QR
                </Button>
              )}
            </div>
          </Card>
          <Card className="card-qr">
            <div className="qr-card-container">
              <div style={{ textAlign: "start" }}>
                <div style={{ color: "#C32340", fontWeight: "bold" }}>
                  Delivery QR Code
                </div>
                <div style={{ marginTop: 12 }}>
                  Here is the QR code for online delivery.
                </div>
               { deliveryQr && 
                <div style={{ marginTop: 12 }}>
                  <Button
                  className="custom-btn"
                    type="primary"
                    style={{ marginRight: 16 }}
                    onClick={()=>reGenerateCode('DELIVERY')}
                  >
                    Regenerate QR
                  </Button>
                  {/* <Button type="primary" className="custom-btn" onClick={()=> downloadImage(deliveryQr.data_url, 'delivery')}>
                    Download QR
                  </Button> */}
                  <Button type="secondary" className="custom-btn" onClick={()=> onDeleteQrType( 'DELIVERY')}
                      style={{borderColor:"#C32340",color:"#C32340",width:"150px"}}>
                      Delete
                    </Button>
                </div>}
              </div>
              {deliveryQr ? 
              <img src={deliveryQr?.data_url} width={100} /> 
              : (
                <Button type="primary" className="custom-btn" style={{ marginRight: 16 }} onClick={()=>generateCode('DELIVERY')}>
                  Generate QR
                </Button>
              )
              }
            </div>
          </Card>
          <Card className="card-qr">
            <div className="qr-card-container">
              <div style={{ textAlign: "start" }}>
                <div style={{ color: "#C32340", fontWeight: "bold" }}>
                  Menu QR Code
                </div>
                <div style={{ marginTop: 12 }}>
                  Here are the QR codes for menu management.
                </div>
              </div>
            </div>
            <div className="qr-table">
              <Table
                dataSource={allQrCode?.meun_qr_codes || []}
                className="overflow-auto"
                pagination={false}
                columns={[
                  {
                    title: "Floor",
                    dataIndex: "floor",
                    key: "floor",
                    render: (e, record) => (
                      <div className="table-row-div">{e}</div>
                    ),
                  },
                  {
                    title: "Table Number",
                    dataIndex: "table_number",
                    key: "table_number",
                    render: (e, record) => (
                      <div className="table-row-div">{e}</div>
                    ),
                  },
                  {
                    title: "Section",
                    dataIndex: "section_name",
                    key: "section_name",
                    render: (e, record) => (
                      <div className="table-row-div">{e}</div>
                    ),
                  },
                  {
                    title: "Table QR Code",
                    dataIndex: "data_url",
                    key: "data_url",
                    render: (e, record) => (
                      <div className="table-row-div">
                        <img src={e} width={90} />
                      </div>
                    ),
                  },
                  {
                    title: "Action",
                    render: (e, record) => (
                      <div className="table-action-div">
                        <div>
                          <Popconfirm
                            title="Sure to delete?"
                            onConfirm={(e) => {
                              e.stopPropagation();
                              onDeleteQr(record.id);
                            }}
                          >
                          <a onClick={() => console.log(record, "floor")}>
                            <DeleteOutlined style={{ fontSize: 22}}/>
                          </a>
                          </Popconfirm>
                        </div>
                        <div className="ml-1">
                          <DownloadOutlined style={{color:"#C32340", fontSize: 22}}onClick={()=>downloadImage(record.data_url, record.section_name)}/>
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
            </div>
          </Card>
        </div>
      </Content>
      <R2Footer />
    </Layout>
  );
}
